import { SELECT_OPTION_ITEM_DATA } from '../../common/select';
import {
  USER_ITEM_DATA_RAW,
  USER_DATA,
  USER_ITEM_LIST_DATA_RAW,
  USER_ITEM_LIST_DATA,
} from './constant';

export const convertUser = (user: USER_ITEM_DATA_RAW): USER_DATA => {
  return {
    ...user,
  };
};

export const convertUserList = (
  userList: USER_ITEM_LIST_DATA_RAW,
): USER_ITEM_LIST_DATA => {
  return {
    list: userList.list?.map((user: USER_ITEM_DATA_RAW) => {
      return convertUser(user);
    }),
    isEmpty: !userList.list?.length,
  };
};

export const convertUserListToSelect = (data: USER_ITEM_DATA_RAW[]) => {
  const newList: SELECT_OPTION_ITEM_DATA[] = [];
  data?.map((item: USER_ITEM_DATA_RAW) => {
    newList.push({
      value: item.id,
      label: item.name,
    });
  });

  return newList;
};
